import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import styles from "../askTheTeamModal/AskTheTeamStyles.module.css";
import "../AdvanceFilters/AFModalsStyles.css";
import "./RequestForUpdateStyles.css";
import { requestForUpdate } from "../../../API/api";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import {replaceContentEditableText} from '../../../utils';
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import Button from "../../../NewComponent/Button/Button";
import Button2 from "../../../NewComponent/Button2/Button2";
import { ModalHeader } from "../../../Constants";
const successfulShareQuestion = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export default function RequestForUpdateModal() {
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, filteringSearchData, UpdatedTrendingData, updateKeyTagData, filteredOrigSearchData, SearchExpDocData } = bindActionCreators(
    Actions,
    dispatch
  );
  const [additionText, setAdditionalText] = useState("");
  const modalState = useSelector((state) => state.domain);
  const searchState = useSelector((state) => state.search);
  const trendingState = useSelector(state=> state.trending)
  const tagState = useSelector(state=>state.keyTag);

  const currentPath = useLocation();
  const onClickSubmit = () => {
    advanceFilterModalToggle({ bool: false, value: "" });
    let payload;
    if (searchState.selectedAnswer.docId) {
      if(searchState.selectedQuestion.docType === 'Thread'){
        payload = {
          additionalContext: additionText,
          questionUuid: searchState.selectedQuestion.questionUuid,
          answerUuid: searchState.selectedAnswer.answerUuid,
          status: "verify",
          questionText: searchState.inputValue, //searchquery
          answerText: searchState.selectedAnswer.threads.join(','),
          docId: searchState.selectedAnswer.docId,
        };
      }else{
        payload = {
          additionalContext: additionText,
          questionUuid: searchState.selectedQuestion.questionUuid,
          answerUuid: searchState.selectedAnswer.answerUuid,
          status: "verify",
          questionText: searchState.inputValue, //searchquery
          answerText: searchState.selectedAnswer.answerCopy === undefined ? searchState.selectedAnswer.answerText: searchState.selectedAnswer.answerCopy,
          docId: searchState.selectedAnswer.docId,
        };
      }
    } else {
      payload = {
        additionalContext: additionText,
        questionUuid: searchState.selectedQuestion.questionUuid,
        answerUuid: searchState.selectedAnswer.answerUuid,
        status: "requires_curation",
        questionText: searchState.inputValue, //searchquery
        answerText: searchState.selectedAnswer.answerCopy,
        botQuestionText: searchState.selectedQuestion.question, // original question
        pdfId: "",
      };
    }
    
    requestForUpdate(payload)
      .then((res) => {
        if (res !== undefined) {
          if(currentPath.pathname.includes('/search/')){
            let newData = searchState.expertData.filter((question) => {
              question.answers.filter((answer) => {
                if (answer.answerUuid === searchState.selectedAnswer.answerUuid) {
                  answer.userInitiatedCuration = true;
                  answer.isVerifyShow = false;
                }
              });
              return question;
            });
            let newData2 = searchState.docData.filter((question) => {
              question.answers.filter((answer) => {
                if (answer.answerUuid === searchState.selectedAnswer.answerUuid) {
                  answer.userInitiatedCuration = true;
                  answer.isVerifyShow = false;
                }
              });
              return question;
            });
            let newData3 = searchState.origRawSearchedData.filter((question) => {
      question.answers.filter((answer) => {
        if (answer.answerUuid === searchState.selectedAnswer.answerUuid) {
          answer.userInitiatedCuration = true;
          answer.isVerifyShow = false;
        }
      });
      return question;
    });
            SearchExpDocData({exp:newData,doc:newData2})
            // filteredOrigSearchData(newData);
            // filteringSearchData(newData2);
          }
          if(currentPath.pathname.includes('/trending')){
            let newData = trendingState.data2.filter((question) => {
              question.answersList.filter((answer) => {
                if (answer.answerUuid === searchState.selectedAnswer.answerUuid) {
                  answer.userInitiatedCuration = true;
                  answer.isVerifyShow = false;
                }
              });
              return question;
            });
            UpdatedTrendingData(newData);

          }
          if(currentPath.pathname.includes('/tagdata')){
            let newData = tagState.data.filter((question) => {
              question.answers.filter((answer) => {
                if (answer.answerUuid === searchState.selectedAnswer.answerUuid) {
                  answer.userInitiatedCuration = true;
                  answer.isVerifyShow = false;
                }
              });
              return question;
            });
            updateKeyTagData(newData);

          }
          if(currentPath.pathname.includes('/keyterm')){
            let newData = tagState.data2.filter((question) => {
              question.answersList.filter((answer) => {
                if (answer.answerUuid === searchState.selectedAnswer.answerUuid) {
                  answer.userInitiatedCuration = true;
                  answer.isVerifyShow = false;
                }
              });
              return question;
            });
            updateKeyTagData(newData);
          }
          toast.success(successfulShareQuestion(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((err) => {});
  };

  const conCatThreadAnswer = (arr) => {
    let str = "";
    for (let i = 0; i < arr.length; ++i) {
      str = `${str}${arr[i]}<br/><br/>`;
    }
    return str;
  };
// console.log(searchState.selectedQuestion);
  return (
    <>
      <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        size={"lg"}
        centered={true}
      >
        <Modal.Header
          closeButton
        >
          <Modal.Title style={ModalHeader.styles}>
          <i class="fa fa-user" aria-hidden="true"></i>
            &nbsp;&nbsp;
            {searchState.selectedAnswer.docId
              ? "Verify with Expert"
              : "Request For Update"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12 col-lg-12">
            <h2 className={`${styles.questionTextInAsk} mb-3`}>
              {searchState.selectedQuestion.question || searchState.inputValue || searchState.selectedQuestion.text}
            </h2>
            {
              trendingState.seekerAttachments && trendingState.seekerAttachments.length > 0 &&
              <div style={{marginBottom:'7px'}}>
                {
                  trendingState.seekerAttachments.map((obj, ind) => {
                    return (<AttachmentBox attachment={obj} key={ind} />)
                  })
                }
              </div>
            }
            {/* <br/> */}
            {searchState.selectedQuestion.docType !== "Thread" && (
              <div className="answerRFU mb-2" dangerouslySetInnerHTML={{ __html: replaceContentEditableText(searchState.selectedAnswer.answerText || searchState.selectedAnswer.answer) }}>
              </div>
            )}
            {searchState.selectedQuestion.docType === "Thread" && (
              <div className="answerRFU mb-2" dangerouslySetInnerHTML={{ __html: conCatThreadAnswer(searchState.selectedAnswer.threads) }} >
              </div>
            )}
            {searchState.selectedQuestion.docType == "Pdf" && searchState.selectedQuestion.url !== undefined && searchState.selectedQuestion.url !== null && (
              <div className="answerRFU mb-2">
                URL: <a href={searchState.selectedQuestion.url} target="_blank">{searchState.selectedQuestion.url}  </a>
              </div>
            )}
            <p className={styles.domainText} style={{ fontWeight: "bold" }}>
              What needs to be updated?
            </p>
            <div className="mb-1">
              <textarea
                value={additionText}
                className="form-control"
                placeholder="Share with Expert your reason for request for update"
                rows="2"
                style={{fontSize:'12px'}}
                onChange={(e) => setAdditionalText(e.target.value)}
              ></textarea>
            </div>
            <br />
            <div
              className="form-check"
              style={{ display: "flex", justifyContent: "flex-end",gap:'5px' }}
            >
              {/* <button
                className={styles.cancelButtonASK}
                onClick={() =>
                  advanceFilterModalToggle({ bool: false, value: "" })
                }
              >
                Cancel
              </button> */}
              <Button2 type="dark" children={'Cancel'} onClickFunc={()=> advanceFilterModalToggle({ bool: false, value: "" })} />
              {/* <button
                className={`${styles.shareSubmitButtonASK} btn btn-primary`}
                onClick={() => onClickSubmit()}
              >
                Ask the Team
              </button> */}
              <Button text='Ask the Team' type={'primary'} onClickFunc={() => onClickSubmit()} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
